export default {
	FOLDERS: 'folders',
	WORDS: 'words',
	SETTINGS: 'settings',
};
